import { getCustomQueries } from '@/helpers/queryHelper';
import {
  ASSIGN_MULTIPLE_MOCK_TEST_FAILED,
  ASSIGN_MULTIPLE_MOCK_TEST_REQUEST,
  ASSIGN_MULTIPLE_MOCK_TEST_SUCCEEDED,
  CLEAR_MOCK_TEST_ASSIGN_ERROR,
  CLEAR_MOCK_TEST_QUERY,
  CLEAR_MOCK_TEST_STATE,
  COUNT_DOWN_TIMER,
  GET_MOCKTEST_LEADERBOARD,
  GET_MOCKTEST_LEADERBOARD_FAILED,
  GET_MOCKTEST_LEADERBOARD_SUCCEEDED,
  GET_MOCK_TEST,
  GET_MOCK_TEST_BY_SLUG,
  GET_MOCK_TEST_BY_SLUG_FAILED,
  GET_MOCK_TEST_BY_SLUG_SUCCEEDED,
  GET_MOCK_TEST_COURSES,
  GET_MOCK_TEST_COURSES_BY_PAGE,
  GET_MOCK_TEST_COURSES_BY_PAGE_FAILED,
  GET_MOCK_TEST_COURSES_BY_PAGE_SUCCEEDED,
  GET_MOCK_TEST_COURSES_FAILED,
  GET_MOCK_TEST_COURSES_SUCCEEDED,
  GET_MOCK_TEST_FAILED,
  GET_MOCK_TEST_LIST,
  GET_MOCK_TEST_LIST_BY_PAGE,
  GET_MOCK_TEST_LIST_BY_PAGE_FAILED,
  GET_MOCK_TEST_LIST_BY_PAGE_SUCCEEDED,
  GET_MOCK_TEST_LIST_BY_SLUG,
  GET_MOCK_TEST_LIST_BY_SLUG_FAILED,
  GET_MOCK_TEST_LIST_BY_SLUG_SUCCEEDED,
  GET_MOCK_TEST_LIST_FAILED,
  GET_MOCK_TEST_LIST_SUCCEEDED,
  GET_MOCK_TEST_REPORT,
  GET_MOCK_TEST_REPORT_ADMIN_PARTNER,
  GET_MOCK_TEST_REPORT_ADMIN_PARTNER_FAILED,
  GET_MOCK_TEST_REPORT_ADMIN_PARTNER_SUCCEEDED,
  GET_MOCK_TEST_REPORT_FAILED,
  GET_MOCK_TEST_REPORT_SUCCEEDED,
  GET_MOCK_TEST_SUCCEEDED,
  GET_WRITING_MOCK_TEST_ANSWER,
  SAVE_WRITING_MOCK_TEST_ANSWER,
  SET_MOCK_TEST_EDIT_DATA,
  SET_MOCK_TEST_QUERY_DATA,
  SUBMIT_MOCK_TEST,
  SUBMIT_MOCK_TEST_FAILED,
  SUBMIT_MOCK_TEST_SUCCEEDED,
  TEST_TIME_FINISHED,
  UPDATE_MOCK_TEST,
  UPDATE_MOCK_TEST_FAILED,
  UPDATE_MOCK_TEST_SUCCEEDED,
} from '.';

export const submitMockTest = (data) => {
  return {
    type: SUBMIT_MOCK_TEST,
    payload: {
      data,
      url: `enrol/model-answer-sheet/`,
      onSuccess: SUBMIT_MOCK_TEST_SUCCEEDED,
      onFailure: SUBMIT_MOCK_TEST_FAILED,
    },
  };
};

export const getMockTestList = ({ data }) => {
  let query = getCustomQueries(data);
  return {
    type: GET_MOCK_TEST_LIST,
    payload: {
      url: `/mock-test/?${query}`,
      onSuccess: GET_MOCK_TEST_LIST_SUCCEEDED,
      onFailure: GET_MOCK_TEST_LIST_FAILED,
    },
  };
};

export const getMockTestListByPage = ({ course = {}, page = {}, per_page = {} }) => {
  return {
    type: GET_MOCK_TEST_LIST_BY_PAGE,
    payload: {
      url: `/mock-test/?course=${course}&page=${page}&per_page=${per_page}`,
      onSuccess: GET_MOCK_TEST_LIST_BY_PAGE_SUCCEEDED,
      onFailure: GET_MOCK_TEST_LIST_BY_PAGE_FAILED,
    },
  };
};

export const getMockTestCourses = ({ data }) => {
  let query = getCustomQueries(data);
  return {
    type: GET_MOCK_TEST_COURSES,
    payload: {
      url: `/mock-test-courses/?${query}`,
      onSuccess: GET_MOCK_TEST_COURSES_SUCCEEDED,
      onFailure: GET_MOCK_TEST_COURSES_FAILED,
    },
  };
};

export const getMockTestCoursesByPage = ({ data }) => {
  let query = getCustomQueries(data);
  return {
    type: GET_MOCK_TEST_COURSES_BY_PAGE,
    payload: {
      url: `/mock-test-courses/?${query}`,
      onSuccess: GET_MOCK_TEST_COURSES_BY_PAGE_SUCCEEDED,
      onFailure: GET_MOCK_TEST_COURSES_BY_PAGE_FAILED,
    },
  };
};

export const getMockTestBySlug = ({ mockTestSlug }) => {
  const currency = window.localStorage.getItem('currency');
  return {
    type: GET_MOCK_TEST_BY_SLUG,
    payload: {
      url: `/mock-test/${mockTestSlug}/?currency=${currency}`,
      onSuccess: GET_MOCK_TEST_BY_SLUG_SUCCEEDED,
      onFailure: GET_MOCK_TEST_BY_SLUG_FAILED,
    },
  };
};

export const getMockTestListBySlug = ({ mockTestSlug }) => {
  const currency = window.localStorage.getItem('currency');
  return {
    type: GET_MOCK_TEST_LIST_BY_SLUG,
    payload: {
      url: `/course-payment-mocktest/${mockTestSlug}/?currency=${currency}`,
      onSuccess: GET_MOCK_TEST_LIST_BY_SLUG_SUCCEEDED,
      onFailure: GET_MOCK_TEST_LIST_BY_SLUG_FAILED,
    },
  };
};

export const getMockTest = (slug) => {
  return {
    type: GET_MOCK_TEST,
    payload: {
      url: `/mock-test/${slug}/`,
      onSuccess: GET_MOCK_TEST_SUCCEEDED,
      onFailure: GET_MOCK_TEST_FAILED,
    },
  };
};

// Assign multiple mock test
export const assignBulkMockTest = (data) => {
  return {
    type: ASSIGN_MULTIPLE_MOCK_TEST_REQUEST,
    payload: {
      data,
      url: `/bulk-assign-mocktest/`,
      onSuccess: ASSIGN_MULTIPLE_MOCK_TEST_SUCCEEDED,
      onFailure: ASSIGN_MULTIPLE_MOCK_TEST_FAILED,
    },
  };
};

export const getMockTestReport = (slug) => {
  return {
    type: GET_MOCK_TEST_REPORT,
    payload: {
      url: `/enrol/model-answer-sheet/${slug}/`,
      onSuccess: GET_MOCK_TEST_REPORT_SUCCEEDED,
      onFailure: GET_MOCK_TEST_REPORT_FAILED,
    },
  };
};

export const getMockTestReportForAdminPartner = (slug, user_id) => {
  return {
    type: GET_MOCK_TEST_REPORT_ADMIN_PARTNER,
    payload: {
      url: `model-answer-sheet/${slug}/user/${user_id}`,
      onSuccess: GET_MOCK_TEST_REPORT_ADMIN_PARTNER_SUCCEEDED,
      onFailure: GET_MOCK_TEST_REPORT_ADMIN_PARTNER_FAILED,
    },
  };
};

export const updateMockTestRequest = ({ mockTestSlug, data }) => {
  return {
    type: UPDATE_MOCK_TEST,
    payload: {
      data,
      url: `update-mock-test/${mockTestSlug}/`,
      onSuccess: UPDATE_MOCK_TEST_SUCCEEDED,
      onFailure: UPDATE_MOCK_TEST_FAILED,
    },
  };
};

export const testTimeFinished = () => {
  return {
    type: TEST_TIME_FINISHED,
  };
};
export const trackCountdown = (payload) => {
  return {
    type: COUNT_DOWN_TIMER,
    payload,
  };
};

export const clearMocktestTime = () => {
  return {
    type: CLEAR_MOCK_TEST_STATE,
  };
};
export const saveAnswerWritingMockTest = (data) => {
  return {
    type: SAVE_WRITING_MOCK_TEST_ANSWER,
    payload: data,
  };
};
export const getAnswerWritingMockTest = (sectionId) => {
  return {
    type: GET_WRITING_MOCK_TEST_ANSWER,
    payload: sectionId,
  };
};
export const setMockTestQueryData = (payload) => {
  return {
    type: SET_MOCK_TEST_QUERY_DATA,
    payload,
  };
};

export const clearQueryData = () => {
  return {
    type: CLEAR_MOCK_TEST_QUERY,
  };
};

export const clearMockTestAssignErrorData = () => {
  return {
    type: CLEAR_MOCK_TEST_ASSIGN_ERROR,
  };
};

export const setMockTestEditData = (payload: any) => {
  return {
    type: SET_MOCK_TEST_EDIT_DATA,
    payload,
  };
};

export const getMockTestLeaderboard = (slug) => {
  return {
    type: GET_MOCKTEST_LEADERBOARD,
    payload: {
      url: `/score-board/${slug}`,
      onSuccess: GET_MOCKTEST_LEADERBOARD_SUCCEEDED,
      onFailure: GET_MOCKTEST_LEADERBOARD_FAILED,
    },
  };
};
